module.exports = __webpack_public_path__ + "img/head.e7af2521.jpg";